import { useCallback, useRef } from 'react';
import { captureLogger as logger } from './configure/logger-facade';

export const useAlertSound = (cooldownTime = 10000) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const lastPlayedRef = useRef<number>(0);

  if (!audioRef.current) {
    audioRef.current = new Audio('/alert.mp3');
    audioRef.current.preload = 'auto';
    audioRef.current.load();
  }

  const playAlert = useCallback(() => {
    const now = Date.now();
    const elapsedTime = now - lastPlayedRef.current;
    if (elapsedTime < cooldownTime) {
      // The ref outlives individual recordings (the hook's host component is
      // long-lived), so back-to-back alerts across recordings mute here too.
      logger.info('[AlertSound] Skipped: within cooldown', {
        elapsedMs: elapsedTime,
        cooldownMs: cooldownTime,
      });
      return;
    }
    if (!audioRef.current) return;
    audioRef.current.currentTime = 0;
    audioRef.current.play().catch((error) => {
      logger.warn('[AlertSound] Playback failed', error);
    });
    lastPlayedRef.current = now;
  }, [cooldownTime]);

  return { playAlert };
};
